type OverlayStyle = {
  left: number
  top: number
  width: number
}

const PANEL_GAP = 8
const PANEL_MIN_WIDTH = 329
const VIEWPORT_PADDING = 8

function resolveUserDropdownPanelStyle(trigger: Element | null): OverlayStyle | null {
  if (!trigger || typeof window === "undefined") {
    return null
  }

  const rect = trigger.getBoundingClientRect()
  const width = Math.max(PANEL_MIN_WIDTH, rect.width)
  const top = rect.bottom + PANEL_GAP
  const left = Math.min(
    Math.max(VIEWPORT_PADDING, rect.right - width),
    Math.max(VIEWPORT_PADDING, window.innerWidth - width - VIEWPORT_PADDING)
  )

  return {
    left,
    top,
    width,
  }
}

export { resolveUserDropdownPanelStyle }
export type { OverlayStyle }
